import React, { Component } from 'react';
import { Redirect} from 'react-router-dom';
import { Input, Row, Modal, Select, DatePicker } from 'antd';
import Button from '../common/atoms/DSButton';

const Option = Select.Option;

class AppointmentsFilter extends Component {

	constructor(props) {
    super(props)
    this.state = {
      locations: this.props.filters.locations,
      departments: this.props.filters.departments,
      appointment_status: this.props.filters.appointment_status,
      filtered: this.props.selected_filters,  
      visible: true,
      error_msg: ""
    }
  }

  handleOk = (e) => {
    this.props.updateFilters(this.state.filtered)
  }

  handleCancel = (e) => {
    this.setState({visible: false},function(){
      this.props.closeModal()
    })
  }

  locationChange(loc) {
    let data = this.state.filtered
    data.selected_locations = loc 
    this.setState({filtered: data})
  }

  departmentChange(dept) {
    let data = this.state.filtered
    data.selected_departments = dept 
    this.setState({filtered: data})
  }

  aptStatusChange(status) {
    let data = this.state.filtered
    if (status.includes("Didn't Booked")){
      status = ["Didn't Booked"]
    }
    data.selected_appointment_status = status 
    this.setState({filtered: data})
  }

  updateDate(date,dateString) {
    let data = this.state.filtered
    let items = dateString.split("-")
    data.selected_appointment_date = dateString
    this.setState({filtered: data})
  }

  render(){
    if (this.state.visible){
      return(
        <Modal
            title="Filters"
            visible={this.state.visible}
            onOk={this.handleOk.bind(this)}
            onCancel={this.handleCancel}
          >
            <h4>Locations</h4>
            <Select
                mode="multiple"
                style={{ width: '100%', backgroundColor: '#fff'}}
                placeholder=""
                onChange={this.locationChange.bind(this)}
                value={this.state.filtered.selected_locations}
            >
                {
                  this.state.locations.map((key) => {
                    return (<Option value={key}>{key} </Option>);
                  })
                }
            </Select>
            <br/>
            <br/>
            <h4>Departments</h4>
            <Select
                mode="multiple"
                style={{ width: '100%', backgroundColor: '#fff'}}
                placeholder=""
                onChange={this.departmentChange.bind(this)}
                value={this.state.filtered.selected_departments}
            >
                {
                  this.state.departments.map((key) => {
                    return (<Option value={key}>{key} </Option>);
                  })
                }
            </Select>
            <br/>
            <br/>
            <h4>Appointment Statuses</h4>
            <Select
                mode="multiple"
                style={{ width: '100%', backgroundColor: '#fff'}}
                placeholder=""
                onChange={this.aptStatusChange.bind(this)}
                value={this.state.filtered.selected_appointment_status}
            >
                {
                  this.state.appointment_status.map((key) => {
                    return (<Option value={key}>{key} </Option>);
                  })
                }
            </Select>
            <br/>
            <br/>
            <h4>Appointment Date</h4>
            <DatePicker onChange={this.updateDate.bind(this)} style={{ width: 485}} />
            <br/>
            <br/>
            <p style={{color: "red"}}>{this.state.error_msg}</p>          
          </Modal>
      )
    }
    else {
      return(<div/>)
    }  
  }

}

export default AppointmentsFilter;  